export function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(initSlider);
}

function initSlider(slider) {
    const slides = [...slider.querySelectorAll('.gallery-slide')];
    const dots = [...slider.querySelectorAll('.module-gallery__dot')];
    const prev = slider.querySelector('.module-gallery__prev');
    const next = slider.querySelector('.module-gallery__next');
    const track = slider.querySelector('.module-gallery__track');
    const autoplay = slider.dataset.autoplay === '1';
    const interval = parseInt(slider.dataset.interval) || 2000;

    if (slides.length <= 1) return;

    let current = 0;
    let timer = null;

    const goTo = (i) => {
        current = (i + slides.length) % slides.length;
        slides.forEach((s, si) => s.classList.toggle('is-active', si === current));
        dots.forEach((d, di) => d.classList.toggle('is-active', di === current));
    };

    const startAuto = () => {
        if (!autoplay) return;
        stopAuto();
        timer = setInterval(() => goTo(current + 1), interval);
    };

    const stopAuto = () => {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    };

    prev?.addEventListener('click', () => { goTo(current - 1); stopAuto(); startAuto(); });
    next?.addEventListener('click', () => { goTo(current + 1); stopAuto(); startAuto(); });
    dots.forEach((d, di) => d.addEventListener('click', () => { goTo(di); stopAuto(); startAuto(); }));

    slider.addEventListener('mouseenter', stopAuto);
    slider.addEventListener('mouseleave', startAuto);

    // Drag / swipe support
    let startX = 0;
    let isDragging = false;
    let wasDragged = false;

    track.addEventListener('pointerdown', (e) => {
        isDragging = true;
        wasDragged = false;
        startX = e.clientX;
        stopAuto();
    });

    track.addEventListener('pointermove', (e) => {
        if (!isDragging) return;
        if (Math.abs(e.clientX - startX) > 5) wasDragged = true;
    });

    track.addEventListener('pointerup', (e) => {
        if (!isDragging) return;
        isDragging = false;

        if (wasDragged) {
            const dx = e.clientX - startX;
            if (Math.abs(dx) > 50) {
                dx < 0 ? goTo(current + 1) : goTo(current - 1);
            }
        }
        startAuto();
    });

    track.addEventListener('pointercancel', () => {
        isDragging = false;
        startAuto();
    });

    const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => e.isIntersecting ? startAuto() : stopAuto());
    });
    io.observe(slider);
}
